import { FC } from "react";
import { Login } from "../packages/customers/Components";

export const LoginPage: FC = () => {
  return <Login></Login>;
};
